import React from 'react';
import { SignatureContainer, UserNameStyle } from './Styled';

interface SignatureProps {
  user: string;
  authorId: string;
  date: string;
  brandName: string;
  column?: boolean;
  marginBottom?: number;
}

const Signature = (props: SignatureProps) => {
  const { brandName, authorId, date } = props;

  const user = props?.user === authorId ? `cliente ${brandName}` : props?.user;
  const userCaptalized = user.charAt(0).toUpperCase() + user.slice(1);

  return (
    <SignatureContainer column={props.column}>
      <UserNameStyle marginBottom={props.marginBottom}>{`${userCaptalized} em ${date}`}</UserNameStyle>
    </SignatureContainer>
  );
};

Signature.defaultProps = {
  user: '',
  authorId: '',
  date: '',
  brandName: '',
  marginBottom: 0,
  column: false,
};

export default Signature;
export { Signature };
